import script from "./MenuMinimized.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuMinimized.vue?vue&type=script&setup=true&lang=ts"

import "./MenuMinimized.vue?vue&type=style&index=0&id=b6302160&lang=scss"

const __exports__ = script;

export default __exports__